import GET_ARTICLES from '../class/getArticles';
import ScrollObserver from '../class/scrollObserver';

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];

class transparentHeader extends ScrollObserver {
  constructor(elm=d.querySelector('.rwd002-header'),opt) {
    opt = Object.assign({
      rootMargin: "0% 0px 0%", // ビューポートの中心を判定基準にする
    }, opt);
    super(opt);
    this.header = elm;
    this.trigger = d.querySelector('.mainvisual');
    this.observeElement();
  }
  observeElement () {
    this.observer = new IntersectionObserver( this.callback.bind(this), this.opt);
    this.observer.observe( this.trigger );
  }
  intersectIn ( entry, object ) {
    this.header.classList.add('is-transparent');
  }
  intersectOut ( entry, object ) {
    this.header.classList.remove('is-transparent');
  }
}

const domReady = TPL => {
  if( mq.matches ) new transparentHeader();

  const news_ticker = new GET_ARTICLES('.mainvisual-ticker__body[data-plugin="getArticles"]');
  news_ticker.makeItem = (item,content) => `
    <a href="${item.href}" class="mainvisual-ticker__link">
      <span class="date">${item.date}</span>
      <strong class="title">${item.title}</strong>
    </a>`;
  // news_ticker.makeItem = (item) => console.log(item);
  news_ticker.render();


  let getArticles = new GET_ARTICLES('.block-news__list[data-plugin="getArticles"]');
  getArticles.makeItem = (item,content) => `
    <li class="block-${content}__item${(item.is_new)? ' is-new':''}">
      <a href="${item.href}" class="block-${content}__item-link">
        <div class="block-${content}__item-head">
          <span class="date">${item.date}</span>
          <span class="cat">${item.category.name}</span>
        </div>
        <!-- /.block-${content}__item-head -->
        <span class="subject">${item.title}</span>
      </a>
      <!-- /.block-${content}__item-link -->
    </li>
    <!-- /.block-${content}__item -->`;
  getArticles.render();

  
  const getContentData = Promise.all([
    getArticles.fetchArticles({
      content: 'news',
      post_per_page: 1,
      category_in: 0
    }),
    getArticles.fetchCategories('news'),
  ]).then( res => Promise.all(res.map(r=>r.json())) );

  let categoryContainer = d.querySelector('.block-news__catlist[data-plugin="getCategories"]');
  getContentData.then( ([noCatArticles,cats]) => {
    categoryContainer.innerHTML = '';
    if( noCatArticles && noCatArticles.length > 0){
      cats.push({id:'0',name:'その他',href:`/news/?mode=list&cat=0`});
    }
    cats.forEach( item => {
      let itemHtml = `<li class="block-news__catitem"><a href="${item.href}">${item.name}</a></li>`;
      categoryContainer.insertAdjacentHTML('beforeend', itemHtml);
    });
  });
};



const jqInit = () => {
  w.jQuery = $

  /****************************
   * movie background
   */
  $.when(
    w.load['loadHtml'],
    $.getScript('/assets/js/vendor/jquery.mb.YTPlayer.min.js')
  ).then( () => {
    const $MV = $('[data-plugin="ytplayer"]')
    const param = id => `{
      videoURL: '${id}',
      containment: '${(mq.matches)? '.mainvisual__wrap':'#allbox'}',
      mute: true,
      showControls: false,
      autoPlay: true,
      useOnMobile: true,
      showYTLogo: false,
      abundance: '${(mq.matches)? 0.01: 0.15}',
      stopMovieOnBlur: false,
      loop: true,
      startAt: 0,
      anchor: 'center,center',
    }`.replace(/\n|\s/g,'')
    $MV.attr('data-property',param('BtaeN4XB1Jw'));
    $MV.YTPlayer();
    $MV.YTPPlay();
  });

};

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());
}